/**
 * Returns a random number between min (inclusive) and max (exclusive)
 *
 * @param  {integer} min
 * @param  {integer} max
 * @return {integer}
 */
export function getRandomInteger(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)

  return Math.floor(Math.random() * (max - min + 1)) + min
}

/**
 * Determine if link is external
 *
 * @param  {string}  url
 * @return {Boolean}
 */
export function isExternalUrl(url) {
  return !/^\/(?!\/)/.test(url)
}

export function formatPrice(number, ...args) {
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: 'USD',
    ...args,
  }).format(number)
}
